import React from 'react'

import { Link, useLocation } from "react-router-dom";
import { Image } from "antd";
import Accordion from "react-bootstrap/Accordion";
import Alert from "react-bootstrap/Alert";
import ButtonWhatsapp from "../components/ButtonWhatsapp";
import Footer from "../components/Footer";


export default function Gallery() {
  const { pathname } = useLocation();
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  const gallery = [
    require("../img/Vehicles/vehicles-34.jpg"),
    require("../img/Vehicles/vehicles-33.jpg"),
    require("../img/Vehicles/vehicles-32.jpg"),
    require("../img/Vehicles/vehicles-31.jpg"),
    require("../img/Vehicles/vehicles-30.jpg"),

    require("../img/Vehicles/bg-slide.jpg"),
    require("../img/Clientes/Selfie.jpg"),
    require("../img/Vehicles/vehicles-9.jpg"),

    require("../img/Clientes/Cliente-1.jpg"),
    require("../img/Vehicles/vehicles-1.jpg"),
    require("../img/Clientes/Cliente-13.jpg"),
    require("../img/Clientes/Cliente-2.jpg"),
    require("../img/Vehicles/vehicles-5.jpg"),
    require("../img/Clientes/Cliente-3.jpg"),
    require("../img/Vehicles/vehicles-2.jpg"),
    require("../img/Clientes/Cliente-12.jpg"),
    require("../img/Vehicles/vehicles-6.jpg"),
    require("../img/Clientes/Cliente-4.jpg"),
    require("../img/Clientes/Cliente-5.jpg"),
    require("../img/Vehicles/vehicles-4.jpg"),
    require("../img/Clientes/Cliente-6.jpg"),
    require("../img/Vehicles/vehicles-8.jpg"),
    require("../img/Clientes/Cliente-7.jpg"),
    require("../img/Vehicles/vehicles-3.jpg"),
    require("../img/Clientes/Cliente-8.jpg"),
    require("../img/Vehicles/vehicles-9.jpg"),
    require("../img/Clientes/Cliente-9.jpg"),
    require("../img/Clientes/Cliente-10.jpg"),

    require("../img/Clientes/Cliente-11.jpg"),



    
  ]

  return (
    <div>
          <div className="container-fluid topbar bg-secondary d-none d-xl-block w-100">
        <div className="container">
          <div
            className="row gx-0 align-items-center"
            style={{ height: "45px" }}
          >
            <div className="col-lg-6 text-center text-lg-start mb-lg-0">
              <div className="d-flex flex-wrap">
                <a  href="https://www.google.com/maps?q=Batalla+de+Puebla,+1ro+de+Mayo,+23406+San+José+del+Cabo,+B.C.S.,+México" className="text-muted me-4"
                
                  target="_blank"
                        rel="noopener noreferrer"
                >
                  <i className="fas fa-map-marker-alt text-primary me-2"></i>
                  Our location
                </a>
                <a href="tel:+5216242302304" className="text-muted me-4"
                     target="_blank" 
                   rel="noopener noreferrer"
                >
                  <i className="fas fa-phone-alt text-primary me-2"></i>
                  +5216242302304
                </a>
                <a href="mailto:reservations@tigresstransport.com.mx" className="text-muted me-0"
                     target="_blank" 
                   rel="noopener noreferrer"
                >
                  <i className="fas fa-envelope text-primary me-2"></i>
                  reservations@tigresstransport.com.mx
                </a>
              </div>
            </div>
            <div className="col-lg-6 text-center text-lg-end">
              <div className="d-flex align-items-center justify-content-end">
                <a
                  href="https://www.facebook.com/profile.php?id=100091411777035"
                  className="btn btn-light btn-sm-square rounded-circle me-3"
                   target="_blank" 
                   rel="noopener noreferrer"
                >
                  <i className="fab fa-facebook-f"></i>
                </a>
{/*                 <a
                  href="#"
                  className="btn btn-light btn-sm-square rounded-circle me-3"
                >
                  <i className="fab fa-twitter"></i>
                </a>
                <a
                  href="#"
                  className="btn btn-light btn-sm-square rounded-circle me-3"
                >
                  <i className="fab fa-instagram"></i>
                </a>
                <a
                  href="#"
                  className="btn btn-light btn-sm-square rounded-circle me-0"
                >
                  <i className="fab fa-linkedin-in"></i>
                </a> */}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid nav-bar sticky-top px-0 px-lg-4 py-2 py-lg-0">
              <div className="container">
                <nav className="navbar navbar-expand-lg navbar-light">
                  <Link to="/" className="navbar-brand p-0">
                    <img src="img/Logo.jpg" alt="Logo" />
                  </Link>
                  <button
                    className="navbar-toggler"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#navbarCollapse"
                  >
                    <span className="fa fa-bars"></span>
                  </button>
      
                  <div className="collapse navbar-collapse" id="navbarCollapse">
                    <div className="navbar-nav mx-auto py-0">
                      <Link to="/" className="nav-item nav-link  ">
                        Home
                      </Link>
                      <div className="nav-item dropdown">
                        <Link
                          href="#"
                          className="nav-link dropdown-toggle active"
                          data-bs-toggle="dropdown "
                        >
                          About us
                        </Link>
                        <div className="dropdown-menu m-0">
                        <Link to="/about-us" className="dropdown-item">
                           About us
                          </Link> 
      
                          <Link
                            to="/private-transportation"
                            className="dropdown-item"
                          >
                            Private Transportation
                          </Link>
                       {/*    <Link to="/shared-shuttle" className="dropdown-item">
                            Shared Shutttle
                          </Link> */}
                          <Link to="/large-groups" className="dropdown-item ">
                            Large Groups
                          </Link>
      
                          <Link to="/gallery" className="dropdown-item active">
                            Gallery
                          </Link>
                        </div>
                      </div>
                      <Link to="/destinations" className="nav-item nav-link ">
                        Destinations
                      </Link>
                      <Link to="/vehicles" className="nav-item nav-link">
                        Our Fleet
                      </Link>
                      <Link to="/reviews" className="nav-item nav-link">
                        Our Reviews
                      </Link>
                      <Link to="/contact-us" className="nav-item nav-link">
                      Contact Us
                      </Link>
                    
                   
                    </div>
                    <Link
                      to="/book-now"
                      className="btn btn-primary rounded-pill py-2 px-4"
                    >
                      Book Now
                    </Link>
                  </div>
                </nav>
              </div>
            </div>

      <div class="container-fluid bg-breadcrumb">
        <div class="container text-center py-5" style={{ maxWidth: "900px" }}>
          <h4
            class="text-white display-4 mb-4 wow fadeInDown"
            data-wow-delay="0.1s"
          >
            Gallery
          </h4>
        </div>
      </div>

    

      <div className="py-5 text-private-transportation">
        <p className=" wow fadeInUp " data-wow-delay="0.1s">
       <strong> Tigress transport </strong>  is dedicated not only to moving people but making travelers happy.
        </p>

        <p className=" wow fadeInUp " data-wow-delay="0.1s">
        Our people are friendly drivers, helpful support staff, and interested management with a common goal of transferring you to and from (SJD) Los Cabos International Airport in complete comfort.
        </p>

       
      </div>

      

  

     
        <div
          class="py-5 wow fadeInUp d-flex flex-wrap justify-content-center gap-2"
          data-wow-delay="0.1s"
        >
          <div class=" d-flex flex-wrap justify-content-center gap-2 " >
                         {gallery && gallery.map((img, index) => (
         
                             <div
                             className="wow fadeInUp"
                             data-wow-delay={`0.${index +1}s`}
                             >
         
                         <Image
                           width={400}
                           height={300}
                           src={img}
                           style={{objectFit: "cover"}}
                        
                           />
                           </div>
                    
                         ))}
         
                     </div>

        </div>
      



      
     
<Footer/>
   <ButtonWhatsapp/>
    </div>
  );
}
